export default "__VITE_ASSET__6444e3f1__"